var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { withAppName } from '@/hoc/api/api-service';
/**
 * VA-26877: ask the backend to build the realtime session before the candidate joins.
 *
 * `session_create` does two slow things while the candidate sits in silence waiting
 * for the greeting: reads the blueprint, and mints an OpenAI client secret (measured
 * at 1.9s in one live run and 12.2s in another — variable, and entirely on the path
 * the candidate waits on). They are meanwhile idle on the device-check and guidelines
 * screens for 20s+, so this moves that work there.
 *
 * Called from the candidate-journey bootstrap, the moment the interview is confirmed
 * joinable — NOT from the websocket connect path. `resolveUserDetails` looked like
 * the natural home because the token is in scope, but it only runs when the socket
 * opens, i.e. at Join: prewarming there would race the very session build it is
 * meant to replace and burn a second OpenAI mint for nothing.
 *
 * Fire-and-forget. The backend answers `{prewarmed: bool}` and we act on neither
 * outcome: a miss means `session_create` builds the session itself, which is the
 * pre-existing behaviour. So there is nothing to retry, nothing to show the
 * candidate, and no reason to delay the screen they are waiting for.
 *
 * NOTE the path carries no extra `/api` segment. `apiBaseUrl` already ends in `/api`
 * and this endpoint is registered as `interview/prewarm/` — unlike
 * `get-interview-from-token`, which is declared WITH an `api/` prefix inside a
 * urlconf already mounted at `api/` and so genuinely lives at `/api/api/...`.
 * Copying that pattern here would 404, exactly as the proctoring-config fetch does.
 */
export const prewarmInterviewSession = (apiBaseUrl, token) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (!apiBaseUrl || !token)
        return;
    try {
        const response = yield fetch(withAppName(`${apiBaseUrl}/interview/prewarm/?token=${encodeURIComponent(token)}`), { method: 'POST' });
        const body = yield response.json().catch(() => null);
        console.info('[realtime] session prewarm requested', {
            status: response.status,
            prewarmed: (_a = body === null || body === void 0 ? void 0 : body.prewarmed) !== null && _a !== void 0 ? _a : null,
            reason: (_b = body === null || body === void 0 ? void 0 : body.reason) !== null && _b !== void 0 ? _b : null,
        });
    }
    catch (err) {
        // Swallowed on purpose — see above.
        console.info('[realtime] session prewarm unavailable', { err: String(err) });
    }
});
